import axios from "axios";
import { getStoredTokens, removeStoredTokens, removeUser } from "../local_store/userLocalStore";
import { saveIntendedRoute } from "../local_store/intendedRouteLocalStore";

const backendURL = process.env.REACT_APP_BACKEND_URL;

export const API = axios.create({
  baseURL: backendURL,
  timeout: 300000, // 5 minutes timeout
});

API.interceptors.request.use(
  (request) => {
    if (request.data?.containsFile) {
      request.headers["Content-Type"] = "multipart/form-data";
    } else {
      request.headers["Content-Type"] = "application/json";
    }

    if (typeof window !== "undefined") {
      const { accessToken } = getStoredTokens();
      if (accessToken && !request.headers["Authorization"]) {
        request.headers["Authorization"] = `Bearer ${accessToken}`;
      } else {
        request.headers["Authorization"] = "Bearer null"
      }
    }
    return request;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const { accessToken } = getStoredTokens();
    if (error.code === "ECONNABORTED" && error.message.includes("timeout")) {
      console.log("Request timed out");
    }

    if ((error.response?.status === 401 || error.response?.status === 402) && accessToken) {
      saveIntendedRoute(window.location.pathname + window.location.search);
      removeUser()
      removeStoredTokens();
      window.location.href = "/auth/login";
    }
    return Promise.reject(error?.response?.data || error?.response || error);
  }
);

export default function axiosInstance(url, method, data) {
  return API({
    url,
    method,
    data,
  });
}
